import styled from 'styled-components'
import { limitLines } from 'src/styles'

type WrapperProps = {
  readOnly?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;

  .tiptap {
    width: 100%;
    color: var(--gray-900);
    padding: var(--spacer-3);
    outline: none;
    opacity: ${({ readOnly }) => (readOnly ? 0.5 : 1)};

    p.is-editor-empty {
      position: relative;
      color: var(--gray-400);

      &:first-child::before {
        content: attr(data-placeholder);
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        float: left;
        pointer-events: none;
        line-height: 1;
        ${limitLines(2)}
      }
    }
  }

  &::before {
    content: '';
    cursor: not-allowed;
    opacity: 0.5;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    display: ${({ readOnly }) => (readOnly ? 'block' : 'none')};
  }
`

Wrapper.displayName = 'Wrapper'
